(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vt-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vt-product-video')) {
  customElements.define('vt-product-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video.addEventListener('play', () => {
        document.querySelectorAll('vt-product-video video').forEach(video => {
          if (video !== this.video && !video.paused) video.pause();
        });
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
      }, options);
      const film = this.closest('[data-vt-film]');
      const preparePoster = () => {
        if (film?.open && this.video.dataset.vtPoster) {
          this.video.poster = this.video.dataset.vtPoster;
          delete this.video.dataset.vtPoster;
        }
      };
      preparePoster();
      film?.addEventListener('toggle', () => {
        if (film.open) preparePoster();
        else this.pause();
      }, options);
      const slide = this.closest('.swiper-slide');
      const wrapper = slide?.parentElement;
      if (wrapper) {
        this.slides = new MutationObserver(() => {
          if (wrapper.querySelector('.swiper-slide-active') && !slide.classList.contains('swiper-slide-active')) this.pause();
        });
        this.slides.observe(wrapper, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) this.pause();
        });
        this.visibility.observe(this);
      }
    }
    pause() {
      if (this.video && !this.video.paused) this.video.pause();
    }
    disconnectedCallback() {
      this.pause();
      this.controller?.abort();
      this.slides?.disconnect();
      this.visibility?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vt-tyre-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root = document) {
    root.querySelectorAll('[data-vt-tyre-finder]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const brand = form.querySelector('[data-tyre-brand]');
      const model = form.querySelector('[data-tyre-model]');
      const size = form.querySelector('[data-tyre-size]');
      const models = Array.from(model.options).slice(1);
      const emptyModel = model.options[0].cloneNode(true);
      let active = [];
      try { active = JSON.parse(form.dataset.activeTags) || []; } catch (_) { /* No saved filters. */ }
      const selectedModel = models.find(option => active.includes(option.dataset.tag));
      if (selectedModel) brand.value = selectedModel.dataset.brand;
      function updateModels(value = '') {
        model.replaceChildren(emptyModel.cloneNode(true), ...models.filter(option => option.dataset.brand === brand.value).map(option => option.cloneNode(true)));
        model.value = value;
        model.disabled = !brand.value || form.dataset.mode === 'size';
      }
      function updateMode() {
        const bySize = form.querySelector('[name="finder-mode"]:checked').value === 'size';
        form.dataset.mode = bySize ? 'size' : 'vehicle';
        form.querySelectorAll('[data-vehicle-field]').forEach(field => { field.hidden = bySize; });
        brand.disabled = bySize;
        brand.required = !bySize;
        model.disabled = bySize || !brand.value;
        model.required = !bySize;
        size.required = bySize;
        size.options[0].textContent = bySize ? size.dataset.chooseLabel : size.dataset.allLabel;
      }
      updateModels(selectedModel ? selectedModel.value : '');
      const selectedSize = Array.from(size.options).find(option => active.includes(option.dataset.tag));
      if (selectedSize) size.value = selectedSize.value;
      if (selectedSize && !selectedModel) form.querySelector('[name="finder-mode"][value="size"]').checked = true;
      form.querySelectorAll('[name="finder-season"]').forEach(input => {
        if (active.includes(input.dataset.tag)) input.checked = true;
      });
      updateMode();
      brand.addEventListener('change', () => { updateModels(); size.value = ''; });
      model.addEventListener('change', () => { size.value = ''; });
      form.querySelectorAll('[name="finder-mode"]').forEach(input => input.addEventListener('change', updateMode));
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const tags = [];
        if (form.dataset.mode === 'vehicle' && model.value) tags.push(model.value);
        if (size.value) tags.push(size.value);
        const season = form.querySelector('[name="finder-season"]:checked');
        if (season.value) tags.push(season.value);
        const target = new URL(form.action, location.origin);
        if (tags.length) target.pathname += '/' + tags.join('+');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) target.searchParams.set('preview_theme_id', preview);
        target.hash = 'VtCatalog';
        location.assign(target.href);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
